import { Controller } from "@hotwired/stimulus"

// Placeholder until Phase E. Will tell the scene-router which [data-scene]
// element is active right now, based on viewport intersection. No GSAP
// bursts, no pulse — strictly viewport-bound activation signal.
export default class extends Controller {
  connect() {}
  disconnect() {}
}
